<template>
  <div style="display: none;">
    <div id="printMe">
      <div class="overlay"></div>
      <div
        v-for="product in productInfos"
        v-bind:key="product.id"
        class="printArea"
        style="width : 60mm;  height: 30mm; margin:auto; text-align:center;"
      >
        <div v-if="product.distinguish != 'distinguish'" :style="style">
          <table style="width: 60mm; height: 30mm; margin: auto; padding-top:36px">
            <tr style="margin: auto; text-align: center; height:20mm;">
              <td>
                <qrcode-vue :value="product.url" level="H" :renderAs="renderAs" :size="QrCodeSize"></qrcode-vue>
              </td>
            </tr>

            <tr style="margin: auto; text-align: center; height: 10mm;">
              <td>
                <p style="font-size: 12px; padding:0px; margin:0px; text-align: center; padding-top:5px">
                  <font class="poppine-font" style="font-size: 12px; padding-right:12px; font-weight:900;">S/N</font>
                  <font class="poppine-font" style="font-size: 12px; font-weight:500;">{{ product.authCode }}</font>
                  <!-- <font>{{ product.authCode }}</font> -->
                </p>
              </td>
            </tr>
          </table>
        </div>
        <div v-else>
          <table>
            <p
              style="margin:0px; padding:0px; width : 55mm; padding-right:2mm; padding-left:2mm; padding-top:5mm; padding-bottom:2mm; text-align: left;"
            >
              인쇄매수 : {{ product.variantPrintCount }} ▲
            </p>
            <div style="width : 52mm;">
              <p
                style="margin:0px; padding:0px; width : 55mm; padding-top:2mm; padding-left:2mm; padding-right:2mm; font-size: 11px; text-align: left; overflow: hidden; text-overflow: ellipsis;display:-webkit-box; -webkit-line-clamp:2;-webkit-box-orient:vertical;"
              >
                {{ product.productName }}
              </p>
              <p
                style="margin:0px; padding:0px; width : 55mm;  padding-left:2mm; padding-right:2mm; font-size: 11px; text-overflow: ellipsis; white-space: nowrap; overflow: hidden; text-align: left;"
              >
                옵션 : {{ product.variantName }}
              </p>
              <p style="margin:0px; padding:0px; width : 55mm;  padding-left:2mm; padding-right:2mm; font-size: 11px; text-align: left;">
                상품코드 : {{ product.productCode }}
              </p>
              <p
                style="margin:0px; padding:0px; width : 55mm;  padding-bottom:2mm; padding-left:2mm;  padding-right:2mm; font-size: 11px; text-align: left;"
              >
                품목코드 : {{ product.variantCode }}
              </p>
            </div>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import M from "@/libs/mapping.js";
import Vue from "vue";
import QrcodeVue from "qrcode.vue";
import VueHtmlToPaper from "vue-html-to-paper";
import CommonMixin from "@/mixins/CommonMixin.js";
import store from "../../../../store";
import sumseikr_40_60 from "@/assets/authservice/custom_print_images/sumseikr_40_60.jpg";

const options = {
  name: "_blank",
  specs: ["fullscreen=yes", "titlebar=no", "scrollbars=yes"],
  styles: ["/style/CustomLAbelType5.css"],
};

Vue.use(VueHtmlToPaper);

export default {
  data() {
    return {
      productInfos: [],
      QrCodeValue: "https://" + store.state.mallId + ".cafe24.com",
      QrCodeSize: "75",
      renderAs: "svg",
      tableDatas: [],
      listCount: 0,
      style: `background-image: url("${sumseikr_40_60}"); background-size: 60mm 40mm;`,
    };
  },
  components: {
    QrcodeVue,
  },
  mixins: [CommonMixin],
  methods: {
    btnOnClick: function() {
      this.tableDatas.push({
        itemname: "item",
        quantity: 1,
        sellingprice: 55,
        amount: 55,
      });
    },
    qrPrint: async function() {
      await this.$htmlToPaper("printMe", options);
    },
    qrCodePringttingContents: async function(data) {
      let idx = 0;
      this.productInfos = [];
      for (var productCode in data) {
        for (var variantCode in data[productCode]) {
          let distinguishData = {
            distinguish: "distinguish",
            productName: data[productCode][variantCode][0][0].product_name,
            variantName: data[productCode][variantCode][0][0].variant_name,
            productCode: productCode,
            variantCode: variantCode,
            variantPrintCount: 0,
          };

          for (var i = 0; i < data[productCode][variantCode].length; i++) {
            for (var j = 0; j < data[productCode][variantCode][i][0].print_count; j++) {
              data[productCode][variantCode][i][0].product_name;
              let serialNumber = data[productCode][variantCode][i][0].serial_number;
              let encrySerialNumber = btoa(encodeURI(data[productCode][variantCode][i][0].serial_number));
              let _url = "https://" + store.state.mallId + ".cafe24.com/registration/index.html";
              // 대표도메인 있으면 대표도메인으로
              if (sessionStorage.getItem(`${this.$store.state.mallId}_domain`)) {
                _url = "https://" + sessionStorage.getItem(`${this.$store.state.mallId}_domain`) + "/registration/index.html";
              }

              let QrData = {
                id: this.listCount,
                url: _url + "?authQrCode=" + encrySerialNumber,
                authCode: serialNumber,
              };
              this.productInfos.push(QrData);
              this.listCount++;
              if (!this.productInfos[idx].variantPrintCount) {
                this.productInfos[idx].variantPrintCount = 0;
              }
              distinguishData["variantPrintCount"]++;
            }
          }
          this.productInfos.push(distinguishData);
        }
      }
    },
    setQrPrintList: async function(data) {
      let getCount = Object.keys(data).length;
      if (!getCount) {
        alert("선택된 상품이 없습니다.");
        return false;
      }
      await this.qrCodePringttingContents(data);

      if (this.listCount == 0) {
        alert("인쇄수량이 없습니다.");
        return false;
      }
      this.qrPrint();
    },
    /**
     * QR 코드 인쇄 설정 정보 가져오기
     */
    getQrcodeSettingInfo: async function() {},
  },
  created: async function() {
    //같은 자식 컴포넌트로 부터 setList 을 emit 한 함수를 on 으로 받아 setProductList 메소드 호출
    this.eventHub.$on("setQrPrintList", this.setQrPrintList);
  },
};
</script>
